import camelCase from "lodash/camelCase";
import mapKeys from "lodash/mapKeys";
import mapValues from "lodash/mapValues";
const formatAuthBackendValidationErrors = (backendErrors, valueFunc = (v) => v) => {
  const backendErrorStrings = mapValues(
    backendErrors,
    (errorArray) => `Server validation error: ${errorArray.join(" ")}`
  );
  return valueFunc(mapKeys(backendErrorStrings, (_, key) => camelCase(key)));
};
export default formatAuthBackendValidationErrors;
